import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";

export const getModelsBySupplierID = createAsyncThunk(
  "DirectPO/getModelsBySupplierID",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        API_ENDPOINT.PURCHASE_MANAGEMENT.DIRECT_PURCHASE_ORDER
          .GET_MODELS_BY_SUPPLIER(id)
      );

      return response?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data || "Failed to fetch models"
      );
    }
  }
);


export const getProductsBySupplierAndModelID = createAsyncThunk(
    "DirectPO/getProductsBySupplierAndModelID",
    async ({ supplierId, modelId }: { supplierId: string; modelId: string }, { rejectWithValue }) => {
      try {
        const response = await Axios.get(
          `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.DIRECT_PURCHASE_ORDER?.GET_PRODUCTS_BY_SUPPLIER_AND_MODEL(supplierId, modelId)}`,
        );
        return response?.data || [];
      } catch (err: any) {
        return rejectWithValue(
          err.response?.data || "Failed to fetch purchase Request Dropdown",
        );
      }
    },
);